import React from 'react';
import PropTypes from 'prop-types';

const SummaryCard = ({ code, label, count, extraClass, active, onClick }) => (
  <div className="col-lg col-md-4 col-sm-6 col-12 mb-2">
    <button
      type="button"
      className={`unassigned-summary-card ${active ? 'active' : ''} ${code ? '' : 'no-click'}`}
      onClick={() => onClick(code)}
      disabled={!code}
    >
      <small>{label}</small>
      <div className={`unassigned-summary-count ${extraClass}`}>{count ?? 0}</div>
    </button>
  </div>
);

SummaryCard.propTypes = {
  code: PropTypes.string,
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  extraClass: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SummaryCard.defaultProps = { code: '', extraClass: '' };

const SummaryCards = ({ summary, activeCard, onCardClick }) => {
  const cards = [
    { code: 'all', label: 'Total unassigned', count: summary?.unassignedCount },
    { code: 'NoNotes', label: 'No notes', count: summary?.noNotesCount },
    { code: 'NotesNoSellerInfo', label: 'Notes, no seller info', count: summary?.notesNoSellerInfoCount },
    { code: 'SellerInfoNoMatch', label: 'Seller info, no match', count: summary?.sellerInfoNoMatchCount },
    { code: '', label: 'Auto-assigned today', count: summary?.autoAssignedToday, extraClass: 'text-success' },
  ];
  return (
    <div className="row mb-2">
      {cards.map((card) => (
        <SummaryCard key={card.label} {...card} active={Boolean(card.code) && activeCard === card.code} onClick={onCardClick} />
      ))}
    </div>
  );
};

SummaryCards.propTypes = {
  summary: PropTypes.object,
  activeCard: PropTypes.string,
  onCardClick: PropTypes.func.isRequired,
};

export default SummaryCards;
